"use client";

/**
 * RichTextComponent
 * Displays rich text content with heading on landing page
 */

import { HtmlDisplay } from "@/components/ui/admin-dash/publications-editor/shared/HtmlDisplay";
import { LandingPageComponent } from "@/features/landing-pages/_logic/types";
import { generateAnchorId } from "@/features/landing-pages/_logic/component-registry";

interface RichTextComponentProps {
  component: LandingPageComponent;
  eventId: number;
  primaryColor: string;
}

export default function RichTextComponent({ component, eventId, primaryColor }: RichTextComponentProps) {
  const title = component.config.title;
  const navigationLabel = component.config.navigationLabel;
  const content = component.config.content;

  // Don't render if there's no content
  if (!content) {
    return null;
  }

  // Generate anchor ID from navigationLabel
  const anchorId = navigationLabel ? generateAnchorId(navigationLabel) : undefined;

  return (
    <section id={anchorId} className="py-16 px-4 bg-white scroll-mt-20">
      <div className="max-w-4xl mx-auto">
        {/* Section Title */}
        {title && <h2 className="text-3xl font-bold mb-8 text-gray-900 text-center">{title}</h2>}

        {/* Rich Text Content */}
        <div
          className="prose prose-lg max-w-none"
          style={
            {
              "--link-color": primaryColor,
            } as React.CSSProperties
          }
        >
          <style jsx>{`
            div :global(a) {
              color: var(--link-color);
              text-decoration: underline;
              transition: opacity 0.2s;
            }
            div :global(a:hover) {
              opacity: 0.8;
            }
          `}</style>
          <HtmlDisplay content={content} />
        </div>
      </div>
    </section>
  );
}
